import React, { useEffect, useState } from "react"
import parse from "html-react-parser"
import isBrowser from "../../utils/isBrowser"
import Heart from "../../images/heart.svg"

import useMyWishlist from "./wishlist/useMyWishlist"
import useCustomer from "../../hooks/useCustomer"

const AnchorLinks = ({
  links,
  compatibleApps,
  buyersGuide,
  selectedVariant,
}) => {
  const customer = useCustomer()
  const { removeFromWishlist, addToWishlist, wishlist, loading } =
    useMyWishlist()

  const isVariantInWishlist = !!wishlist?.find?.(
    item => item.variant.node.id === selectedVariant?.shopifyId
  )

  const heartEmoji =
    isBrowser && document.getElementById(Heart?.defaultProps?.id)

  const player = heartEmoji && heartEmoji.svgatorPlayer

  const [heartState, setHeartState] = useState(false)
  const [heartOnLoad, setHeartOnLoad] = useState(true)

  useEffect(() => {
    if (!isVariantInWishlist) {
      setHeartState(false)
      player?.stop()
    } else {
      setHeartState(true)
      player?.play()
    }
  }, [isVariantInWishlist])

  const handleInitialLoad = () => {
    if (isBrowser && isVariantInWishlist) {
      setHeartState(true)
      player?.play()
    } else {
      return null
    }
  }

  if (isBrowser && isVariantInWishlist && heartOnLoad && !heartState) {
    return handleInitialLoad()
  }

  const handleRemoveWishlist = () => {
    if (wishlist) {
      setHeartState(false)
      setHeartOnLoad(false)
      player?.stop()
      removeFromWishlist(selectedVariant?.shopifyId)
    } else {
      console.log("Something went wrong")
    }
  }

  const handleAddWishlist = () => {
    if (customer?.is_logged_in === "true" && wishlist && !loading) {
      setHeartState(true)
      player?.play()
      addToWishlist(selectedVariant?.shopifyId)
    } else {
      isBrowser &&
        (window.location.href = `https://${process.env.GATSBY_CUSTOM_SHOPIFY_DOMAIN}/account/login`)
    }
  }

  return (
    <>
      <div className="font-darkGrey text-[14px] font-normal underline">
        <div className="relative right-[12px] w-fit cursor-pointer items-center justify-between whitespace-nowrap hover:text-darkBlue">
          {heartState ? (
            customer?.is_logged_in === "true" && (
              <button
                className=" flex flex-row items-center"
                onClick={() => handleRemoveWishlist()}
              >
                <Heart className="w-[30px]" />{" "}
                <p className="ml-[2px]">Remove from Wishlist</p>
              </button>
            )
          ) : (
            <button
              className=" flex flex-row items-center"
              onClick={() => handleAddWishlist()}
            >
              <Heart className="w-[30px]" />{" "}
              <p className="ml-[2px]">Add to Wishlist</p>
            </button>
          )}
          {/* ♥ */}
        </div>
      </div>

      {buyersGuide && (
        <div className="font-darkGrey text-[14px] font-normal underline">
          <a className="hover:text-darkBlue" href="#buyers-guide">
            Buyers Guide
          </a>
        </div>
      )}
      {compatibleApps && (
        <div className="font-darkGrey text-[14px] font-normal underline">
          <a className="hover:text-darkBlue" href="#compatible-apps">
            Compatible Fitness Apps & Resources
          </a>
        </div>
      )}

      {links?.map?.((anchor, index) => {
        return (
          anchor && (
            <div
              key={index}
              className="font-darkGrey text-[14px] font-normal underline"
            >
              <a className="hover:text-darkBlue" href={anchor?.link?.url}>
                {parse(anchor?.link?.title)}
              </a>
            </div>
          )
        )
      })}
    </>
  )
}

export default AnchorLinks
